export interface ModalProps {
  modalType: "Create" | "Edit";
  group: string;
  status: boolean;
  onClose: () => void;
  setting: Setting;
}

export const EmptySetting: Setting = {
  ID: 0,
  CreatedAt: "",
  UpdatedAt: "",
  DeletedAt: null,

  Name: "EmptySetting",
  GroupId: 123,
  TargetType: "image",

  EmbedImageRefer: 0,
  EmbedAudioRefer: 0,
  EmbedVideoRefer: 0,
  EmbedImage: {
    ID: 1,
    CreatedAt: "",
    UpdatedAt: "",
    DeletedAt: "",
    Invisible: false,
    VisibleText: false,
    VisibleFile: false,
    TemplateType: 1,
    Opacity: 50,
  },
  EmbedAudio: {
    ID: 1,
    CreatedAt: "",
    UpdatedAt: "",
    DeletedAt: "",
    Inaudible: false,
    AudibleFile: false,
    AudibleTts: false,
    Delay: 10,
    StartTime: 0,
    Volume: 100,
  },
  EmbedVideo: {
    ID: 1,
    CreatedAt: "",
    UpdatedAt: "",
    DeletedAt: "",
    Invisible: false,

    VisibleText: false,
    VisibleFile: false,    
    TemplateType: 1,

    Inaudible: false,
    AudibleFile: false,
    AudibleTts: false,
    
    Delay: 10,
    StartTime: 0,
    
    Opacity: 50,
    Volume: 100,
  },
};
